<template>
    <c-dialog ref="dialog" mode="slide" width="50vw" mask-close :button="false">
        <template #head>
            <div class="m-detail-tag flex-center-cross">
                <label v-if="afterSale.after_sale_no">{{afterSale.after_sale_no}}</label>
                <c-state v-if="afterSale.after_sale_no" tag async dict="SALE_AFTER_SALE_STATE" :value="afterSale.after_sale_state"></c-state>
                <span v-if="saasName" class="m-detail-saas">{{saasName}}</span>
            </div>
        </template>

        <div class="m-after-sale-detail">
            <c-title>基础信息</c-title>
            <c-detail class="m-detail-table" column="2">
                <c-detail-item label="所属商户" colspan="2">{{saasName || '-'}}</c-detail-item>
                <c-detail-item label="订单号" colspan="2">{{afterSale.order_no || '-'}}</c-detail-item>
                <c-detail-item label="创建时间" colspan="2">{{afterSale.create_date || '-'}}</c-detail-item>
                <c-detail-item label="售出价">{{formatPrice(product.sale_price)}}</c-detail-item>
                <c-detail-item label="售后类型">
                    <c-state async dict="SALE_AFTER_SALE_TYPE" :value="afterSale.after_sale_type"></c-state>
                </c-detail-item>
                <c-detail-item :label="afterSale.after_sale_type == 1 ? '退款金额' : '补差金额'">
                    <span class="m-amount">{{formatPrice(afterSale.after_sale_amount)}}</span>
                </c-detail-item>
                <c-detail-item label="退款信息">
                    <span v-if="!Number(afterSale.refund_amount)">-</span>
                    <div v-else class="m-product-info">
                        <p class="m-amount">{{formatPrice(afterSale.refund_amount)}}</p>
                        <p class="m-product-info-code">{{afterSale.refund_date || '-'}}</p>
                    </div>
                </c-detail-item>
                <c-detail-item label="售后原因">{{afterSale.refund_reason || '-'}}</c-detail-item>
            </c-detail>

            <c-title>产品信息</c-title>
            <h3 class="m-product-title">{{getProductFullName()}}</h3>
            <c-detail class="m-detail-table" column="2">
                <c-detail-item label="品牌/型号" colspan="2">{{getBrandModelText()}}</c-detail-item>
                <c-detail-item label="背贴码" colspan="2">{{product.produce_code || '-'}}</c-detail-item>
                <c-detail-item label="IMEI" colspan="2">{{product.imei || '-'}}</c-detail-item>
                <c-detail-item label="分类">{{product.category_name || '-'}}</c-detail-item>
                <c-detail-item label="等级">{{product.level_name || '-'}}</c-detail-item>
                <c-detail-item label="内存">{{product.memory_name || '-'}}</c-detail-item>
                <c-detail-item label="颜色">{{product.color_name || '-'}}</c-detail-item>
            </c-detail>

            <template v-if="afterSale.after_sale_state == 2 || afterSale.after_sale_state == 6">
                <c-title>审批信息</c-title>
                <c-detail class="m-detail-table" column="2">
                    <c-detail-item label="审批人">{{afterSale.audit_user_realname || '-'}}</c-detail-item>
                    <c-detail-item label="审批时间">{{afterSale.audit_date || '-'}}</c-detail-item>
                    <c-detail-item label="驳回原因">{{afterSale.audit_remark || '-'}}</c-detail-item>
                </c-detail>
            </template>

            <template v-if="afterSale.after_sale_state == 7">
                <c-title>撤销信息</c-title>
                <c-detail class="m-detail-table" column="2">
                    <c-detail-item label="撤销人">{{afterSale.cancel_user_realname || '-'}}</c-detail-item>
                    <c-detail-item label="撤销时间">{{afterSale.cancel_date || '-'}}</c-detail-item>
                </c-detail>
            </template>
        </div>
    </c-dialog>
</template>

<script>
export default {
    name: 'erpOfflineAftersaleDetail',

    data() {
        return {
            saasName: '',
            afterSaleId: '',
            productId: '',
            afterSale: {},
            product: {}
        }
    },

    methods: {
        /*********打开抽屉（data=列表行）**********/
        open(data = {}) {
            this.saasName = data.saas_name || '';
            this.afterSaleId = data.after_sale_id;
            this.productId = data.id;
            this.afterSale = {};
            this.product = {};
            this.$refs.dialog.open({title: '线下售后单详情'});
            this.request({
                url: '/aftersale/ops/product_detail',
                data: {
                    merchant_id: data.saas_id,
                    id: this.afterSaleId,
                    after_sale_product_id: this.productId
                },
                loading: true,
                success: data => {
                    this.afterSale = data.order_info || {};
                    this.product = data.product_info || {};
                }
            });
        },

        /*********格式化价格**********/
        formatPrice(price) {
            if (price === null || price === undefined || price === '') return '-';
            return '¥' + parseFloat(price).toFixed(2);
        },

        /*********获取完整产品名称**********/
        getProductFullName() {
            var p = this.product;
            var parts = [];
            if (p.brand_name) parts.push(p.brand_name);
            if (p.model_name) parts.push(p.model_name);
            if (p.color_name) parts.push(p.color_name);
            if (p.memory_name) parts.push(p.memory_name);
            return parts.join(' ') || this.afterSale.product_name || '-';
        },

        /*********获取品牌/型号文本**********/
        getBrandModelText() {
            var p = this.product;
            var parts = [];
            if (p.brand_name) parts.push(p.brand_name);
            if (p.model_name) parts.push(p.model_name);
            return parts.join(' / ') || '-';
        }
    }
}
</script>

<style scoped>
.m-after-sale-detail {
    padding: 0 20px 20px;
}

.m-product-title {
    text-align: center;
    font-size: 16px;
    font-weight: bold;
    margin: 0 0 20px 0;
    color: #333;
}

.m-detail-table ::v-deep .c-detail-item-label {
    background-color: #fafafa;
    color: #666;
    text-align: right;
}

.m-detail-table .m-amount {
    color: #e53e3e;
    font-weight: bold;
}

.m-detail-tag {
    gap: 8px;
    font-size: 14px;
    font-weight: bold;
}

.m-detail-saas {
    font-size: 12px;
    font-weight: normal;
    color: #999;
}

.m-product-info {
    line-height: 24px;
    font-size: 13px;
    color: #333;
}

.m-product-info p {
    margin: 0;
}
</style>
